// MODAL
var showModal;
var hideModal;

function modal() {
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
      if (ancestor.matches(s)) return ancestor;
      ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }
  var settings = {
    speedOpen: 50,
    speedClose: 150,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-modal-target]',
    selectorTrigger: '[data-modal-trigger]',
    selectorClose: '[data-modal-close]',
  };
  var toggleccessibility = function (event) {
    if (event.getAttribute('aria-expanded') === 'true') {
      event.setAttribute('aria-expanded', false);
    } else {
      event.setAttribute('aria-expanded', true);
    }   
  };

  var openModal = function (trigger) {
    var target = document.getElementById(trigger.getAttribute('aria-controls'));
    target.classList.add(settings.activeClass);
    document.documentElement.style.overflow = 'hidden';
    toggleccessibility(trigger);
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen); 
  };

  var closeModal = function (event) {
    var closestParent = event.closest(settings.selectorTarget);
    closestParent.classList.remove(settings.visibleClass);
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);             
  };

  var clickHandler = function (event) {
    var toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);
    if (open) {
      openModal(open);
    }
    if (close) {
      closeModal(close);
    }
    if (open || close) {
      event.preventDefault();
    }
  };

  var keydownHandler = function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      var modals = document.querySelectorAll(settings.selectorTarget),i;
      for (var i = 0; i < modals.length; ++i) {
        if (modals[i].classList.contains(settings.activeClass)) {
          closeModal(modals[i]);
        }
      }
    }
  };

  showModal = function (modalName) {
    var target = document.getElementById(modalName);
    target.classList.add(settings.activeClass);
    target.setAttribute('aria-expanded', true);
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen); 

  };

  hideModal = function (modalName) {
    var target = document.querySelector('.is-active');
    target.classList.remove(settings.activeClass);
    target.setAttribute('aria-expanded', false);
    document.documentElement.style.overflow = '';
    setTimeout(function () {
      target.classList.remove(settings.visibleClass);
    }, settings.speedClose); 
  };

  document.addEventListener('click', clickHandler, false);
  document.addEventListener('keydown', keydownHandler, false);

};
modal();